import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Services";
import getToken from "app/api/getToken";
import { IService } from "app/api/types/Services";

export const DELETE_SERVICE_REQUEST = "DELETE_SERVICE_REQUEST";
export const DELETE_SERVICE_SUCCESS = "DELETE_SERVICE_SUCCESS";
export const DELETE_SERVICE_FAIL = "DELETE_SERVICE_FAIL";

export const delService = (email: IService["id"]) => (dispatch: any): any => {
  dispatch({ type: DELETE_SERVICE_REQUEST });

  const token = getToken();

  return api
    .delService(token, email)
    .then((response: AxiosResponse) => {
      dispatch({ type: DELETE_SERVICE_SUCCESS });
    })
    .catch(err => {
      dispatch({
        type: DELETE_SERVICE_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
